<cipo-dynamic-module-table
    fxFlex="grow"
    class="m-x cipo--overflow--auto"
    [context]="tableContext()"
    [tableOptions]="tableOptions()"
    [reload]="reloadTable()"
    [(filtersToApply)]="filtersToApply"
    (actionSelected)="openDocument($event.data)"
    data-testid="relations-tab-table" />
